import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import CustomerField from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/CustomerField'
import DeliveryTimeSelector from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector'
import { fieldStyles } from '@/features/pos/components/OrderFinalization/parts/FormFields/styles'
import { useScreenLayout } from '@/hooks/screen'
import { FC, useState } from 'react'
import { View } from 'react-native'

interface PhoneModeFieldsProps {
    deliveryTypeCategories: DeliveryTypeCategory[]
}

const PhoneModeFields: FC<PhoneModeFieldsProps> = ({ deliveryTypeCategories }) => {
    const layout = useScreenLayout()
    const [rowWidth, setRowWidth] = useState(0)

    return (
        <View
            onLayout={(event) => setRowWidth(event.nativeEvent.layout.width)}
            style={[
                fieldStyles.splitFieldsRow,
                layout === 'compact' && fieldStyles.splitFieldsRowCompact,
            ]}
        >
            <View style={fieldStyles.customerField}>
                <CustomerField deliveryTypeCategories={deliveryTypeCategories} />
            </View>
            <View
                style={[
                    fieldStyles.timeField,
                    layout === 'compact' && fieldStyles.timeFieldCompact,
                    fieldStyles.topField,
                ]}
            >
                <DeliveryTimeSelector contentWidth={rowWidth || 'anchor'} />
            </View>
        </View>
    )
}

export default PhoneModeFields
